import React, { FC } from 'react';
import { getLoanTypeNameFromLoanTypeId } from '../../../helpers';
import { LoanType, Loan } from '../../../interfaces';
import { EquityFinanceLoanDetail } from './EquityFinanceLoanDetail';
import { MortgageLoanDetail } from './MortgageLoanDetail';
import { PaydayLoanDetail } from './PaydayLoanDetail';
import { RentLoanDetail } from './RentLoanDetail';

type Props = {
  loan: Loan;
};

export const LoanInformation: FC<Props> = ({ loan }) => {
  switch (getLoanTypeNameFromLoanTypeId(loan.loan_type_id)) {
    case LoanType.MORTGAGE:
      return <MortgageLoanDetail loan={loan} />;
    case LoanType.EQUITY_FINANCE:
      return <EquityFinanceLoanDetail loan={loan} />;
    case LoanType.PAYDAY:
      return <PaydayLoanDetail loan={loan} />;
    case LoanType.RENT:
      return <RentLoanDetail loan={loan} />;
    default:
      return <PaydayLoanDetail loan={loan} />;
  }
};
